/* global Chart */

import { onReady } from "../../utils/events/onReady";
import chartData from "../../../.storybook/rcc-data.json";
export class RccCalculator {
    constructor(domReference) {
        this.dom = {
            container: domReference,
            classList: { hiddenClass: "hidden" },
        };

        onReady(() => this.init());
    }
    async init() {
        await this.initCharts();
    }
    async initCharts() {
        const initialDataId = this.dom.container.querySelector(
            ".rcc__dropdown option:first-child",
        ).value;
        const json = chartData[initialDataId];
        const barChart = new Chart("bar-chart", {
            type: "bar",
            options: this.getChartOptions(),
            data: json?.leftGraphJson.barchart,
        });

        this.updateTableContent(json);
        this.updateContainers(json);
        const doughnutChart = new Chart("doughnut-chart", {
            type: "doughnut",
            data: json?.rightGraphJson.circlediagram[0],
            options: this.getDoughnutChartOptions(
                json?.rightGraphJson.circlediagram[0].title,
            ),
            plugins: [
                this.getDoughnutLabel(
                    json?.rightGraphJson.circlediagram[0].datasets[1]
                        .backgroundColor[0],
                ),
            ],
        });
        const doughnutChart2 = new Chart("doughnut-chart-2", {
            type: "doughnut",
            data: json?.rightGraphJson.circlediagram[1],
            options: this.getDoughnutChartOptions(
                json?.rightGraphJson.circlediagram[1].title,
            ),
            plugins: [
                this.getDoughnutLabel(
                    json?.rightGraphJson.circlediagram[1].datasets[1]
                        .backgroundColor[0],
                ),
            ],
        });
        this.setupDropdown(barChart, doughnutChart, doughnutChart2);
    }

    getChartOptions() {
        return {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: { usePointStyle: true, color: "black" },
                },
            },
            scales: {
                y: {
                    grid: { display: true },
                    max: 80,
                    min: 0,
                    ticks: {
                        stepSize: 10,
                        textStrokeColor: "#cccccc",
                        color: "#000",
                    },
                    title: {
                        display: true,
                        text: "Amount of months",
                    },
                },
                x: {
                    grid: { display: true },
                    stacked: false,
                },
            },
        };
    }

    getDoughnutChartOptions(title) {
        return {
            responsive: false,
            cutout: "70%",
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        color: "black",
                        generateLabels: (chart) => {
                            const originalLabels =
                                Chart.overrides.doughnut.plugins.legend.labels.generateLabels(
                                    chart,
                                );
                            return originalLabels.slice(
                                0,
                                originalLabels.length - 2,
                            );
                        },
                    },
                },
                title: {
                    display: true,
                    text: title,
                    color: "black",
                    font: {
                        weight: 400,
                    },
                },
            },
        };
    }

    getDoughnutLabel(dotColor) {
        return {
            id: "doughnutLabel",
            beforeDatasetsDraw: (chart) => {
                const { ctx, data } = chart;
                ctx.save();
                const { x, y } = chart.getDatasetMeta(0).data[0];
                // Draw a circle above the text
                const circleRadius = 7;
                ctx.beginPath();
                ctx.arc(x, y - 35, circleRadius, 0, Math.PI * 2);
                ctx.fillStyle = dotColor; // Circle color
                ctx.fill();
                ctx.closePath();
                // Draw the text
                ctx.font = "bold 24px sans-serif";
                ctx.fillStyle = "#202020";
                ctx.textAlign = "center";
                ctx.textBaseline = "bottom";
                ctx.fillText(data.labels[data.labels.length - 2], x, y);
                ctx.textBaseline = "top";
                ctx.fillText(
                    data.datasets[1].data[data.datasets[1].data.length - 2] ===
                        0
                        ? "-"
                        : `${
                              data.datasets[1].data[
                                  data.datasets[1].data.length - 2
                              ]
                          }%`,
                    x,
                    y,
                );
                ctx.restore();
            },
        };
    }

    updateTableContent(json) {
        const mobileTable = this.dom.container.querySelector(
            ".rcc__table--mobile",
        );
        const desktopTable = this.dom.container.querySelector(
            ".rcc__table--desktop",
        );
        const tableFooter =
            this.dom.container.querySelector(".rcc__table-footer");

        mobileTable.innerHTML = json.mobileTable;
        desktopTable.innerHTML = json.desktopTable;
        tableFooter.innerHTML = json.tableDescriptionText;
    }

    updateContainers(json) {
        const leftContainer = this.dom.container.querySelector(
            ".rcc__container-left",
        );
        const rightContainer = this.dom.container.querySelector(
            ".rcc__container-right",
        );

        this.updateContainerData(
            leftContainer,
            json.leftGraphBottomDescription,
            json.leftGraphTitle,
            json.leftGraphDescription,
        );
        this.updateContainerData(
            rightContainer,
            json.rightGraphBottomDescription,
            json.rightGraphTitle,
            json.rightGraphDescription,
        );
    }

    updateContainerData(container, captionText, titleText, descriptionText) {
        const caption = container.querySelector(".rcc__container-caption");
        const title = container.querySelector(".rcc__container-title");
        const description = container.querySelector(
            ".rcc__container-description",
        );

        caption.innerHTML = captionText;
        title.innerHTML = titleText;
        description.innerHTML = descriptionText;
    }

    setupDropdown(barChart, doughnutChart, doughnutChart2) {
        const dropdown = this.dom.container.querySelector(".rcc__dropdown");
        const disclaimer = this.dom.container.querySelector(".rcc__disclaimer");

        dropdown.addEventListener("change", async (e) => {
            disclaimer.innerHTML = chartData[e.target.value].disclaimerText;

            const barData =
                chartData[e.target.value].leftGraphJson.barchart.datasets;
            const doughnutData =
                chartData[e.target.value].rightGraphJson.circlediagram[0]
                    .datasets;
            const doughnutData2 =
                chartData[e.target.value].rightGraphJson.circlediagram[1]
                    .datasets;
            barChart.config.data.datasets.forEach((dataset, index) => {
                dataset.label = barData[index].label;
                dataset.data = barData[index].data;
            });
            barChart.update();

            doughnutChart.config.data.labels =
                chartData[
                    e.target.value
                ].rightGraphJson.circlediagram[0].labels;
            doughnutChart.config.options.plugins.title.text =
                chartData[e.target.value].rightGraphJson.circlediagram[0].title;
            doughnutChart.config.data.datasets.forEach((dataset, index) => {
                dataset.data = doughnutData[index].data;
            });
            doughnutChart.update();

            doughnutChart2.config.data.labels =
                chartData[
                    e.target.value
                ].rightGraphJson.circlediagram[1].labels;
            doughnutChart2.config.options.plugins.title.text =
                chartData[e.target.value].rightGraphJson.circlediagram[1].title;
            doughnutChart2.config.data.datasets.forEach((dataset, index) => {
                dataset.data = doughnutData2[index].data;
            });
            doughnutChart2.update();

            this.updateTableContent(chartData[e.target.value]);
            this.updateContainers(chartData[e.target.value]);
        });
    }
}
